import React from 'react';
import { Icon, IconStack } from 'js/components';
import {
  faLightbulbExclamation,
  faMagnifyingGlassChart,
  faThoughtBubble,
} from '@fortawesome/pro-regular-svg-icons';
import { faSparkle } from '@fortawesome/pro-solid-svg-icons';

export default function EmptyAnalysisIcon({ className = 'mr-3' }) {
  return (
    <IconStack size="4x" fixedWidth className={className}>
      <Icon icon={faMagnifyingGlassChart} transform="shrink-8 right-1 down-4" />
      <Icon icon={faThoughtBubble} transform="shrink-8 left-4 up-3" />
      <Icon icon={faLightbulbExclamation} transform="shrink-8 right-7 up-2.5" />
      <Icon icon={faSparkle} transform="shrink-13 left-6 down-5" />
      <Icon icon={faSparkle} transform="shrink-14 right-6 down-4" />
      <Icon icon={faSparkle} transform="shrink-14.5 right-2 up-2" />
    </IconStack>
  );
}
